import { render, staticRenderFns } from "./RemoteFolderConfigurationDetails.vue?vue&type=template&id=01da5b2d&"
import script from "./RemoteFolderConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./RemoteFolderConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01da5b2d')) {
      api.createRecord('01da5b2d', component.options)
    } else {
      api.reload('01da5b2d', component.options)
    }
    module.hot.accept("./RemoteFolderConfigurationDetails.vue?vue&type=template&id=01da5b2d&", function () {
      api.rerender('01da5b2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/RemoteFolderConfigurationDetails.vue"
export default component.exports